// import { Tooltip } from "bootstrap";
import React, { Component } from "react";
import { UncontrolledTooltip, Tooltip } from "reactstrap";
import { ajaxValidate } from "../common/networkRequests";
import { goToName } from "../oro-module/commonFunctions";
import { domainFunctions } from "../oro-module/domainFunctions";

class TextCustom extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000)) + 1,
      extraClass: "",
      errorMessage: "",
      compressed: "", val: "",
      tooltipOpen: false
    };
  }

  handleBlur = (e) => {
    let { onLeave, name, liveValidation } = this.props.component;
    if (name == 'land_area') {
      let maxamt = parseFloat(e.target.value) * 25000;
      if (!isNaN(maxamt)) {
        this.props.liftState({ name: 'max_amount' }, maxamt);
        this.props.liftState({ name: 'insurance' }, maxamt * .1);
      } else {
        this.props.liftState({ name: 'max_amount' }, 0);
        this.props.liftState({ name: 'insurance' }, 0);
      }
    } else if (name == 'land_value') {
      let maxamt = parseFloat(e.target.value) * this.props.parentState.pageData['land_area'];
      if (!isNaN(maxamt)) {
        this.props.liftState({ name: 'total_land_value' }, maxamt);
      } else {
        this.props.liftState({ name: 'total_land_value' }, 0);
      }
    }
  }

  shouldComponentUpdate(prevProps, prevState) {
    // Only use for heavy components that need more resources while rendering. Else the following will take up more resources. 

    let shouldProceed = true;
    let { component, parentState } = this.props;

    let current = this;
    if (shouldProceed == true) {
      if (component.onRender) {
        let allResults = {};
        component.onRender.map(func => {
          let { calcType, inputs, resultVar } = func;
          allResults[resultVar] = domainFunctions[func.f]({ parentState, calcType, inputs, allResults, current });
        });
        // console.log(allResults)
      }
    }
    return shouldProceed;
  }

  handleChange(e) {
    // All the validations
    let { currentPage } = this.props.parentState;
    let { name, liveValidation, validations } = this.props.component;

    let errorMessage = "";

    if (validations) {
      validations.map(validation => {
        let patt = new RegExp(validation.rule);
        // let result = patt.exec(e.target.value);
        // let result = patt.test(e.target.value);
        let result = e.target.value.match(patt);

        if (!result || result[0] != e.target.value) {
          if (
            (!this.props.component.isRequired == true &&
              String(e.target.value).length != 0) ||
            this.props.component.isRequired
          ) {
            this.setState({ errorMessage: validation.message });
            this.setState({ extraClass: "validationError" });
            errorMessage = validation.message;
          } else {
            this.setState({ errorMessage: "" });
            this.setState({ extraClass: "" });
            errorMessage = "";
          }
        } else {
          this.setState({ extraClass: "validationSuccess" });
          this.setState({ errorMessage: "" });
          errorMessage = "";
        }
      });
    }

    // Convert case. Remove (to disable) invalid chars. lift form errors to avoid form submission.
    let x = this.props.parentState.errorMessages;
    x[this.props.component.name] = errorMessage;
    this.props.liftGlobalState({ name: "errorMessages" }, x);

    let myvalue = e.target.value;
    if (this.props.component.textType == "number") {
      if (String(myvalue).indexOf(".") == -1) {
        myvalue = parseInt(myvalue);
      } else {
        myvalue = parseFloat(myvalue);
      }
    }

    this.props.liftState(this.props.component, myvalue);

    if (liveValidation) {
      ajaxValidate({ value: myvalue, fieldName: name, liveValidation, current: this });
    }


  }

  componentDidMount() {
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData, defaultValue } = this.props.component;

    if (
      pageData && !fileFolder.isOpen &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      defaultValue
    ) {
      let v = defaultValue;

      if (this.props.component.textType == "number") {
        if (String(v).indexOf(".") == -1) {
          v = parseInt(v);
        } else {
          v = parseFloat(v);
        }
      }
      if (defaultValue == 'assigned_bank_uid') {
        let { profile } = this.props.parentProps.parentState;
        defaultValue = profile[defaultValue]
      }
      this.props.liftState(this.props.component, defaultValue);
    }
  }

  generateID() {
    return this.state.ttid;
  }

  generateID2() {
    return this.state.ttid2;
  }
  toggle = () => this.setState({ 'tooltipOpen': !this.state.tooltipOpen });

  render() {
    const {
      name,
      label,
      placeHolder,
      isRequired,
      description,
      mainHeader,
      focus,
      disabled,
      isReadOnly,
      tabindex,
      maxlength,
      onLeave,
      style,
      insertonly,
      tab,
      next_field,
      hidden

    } = this.props.component;
    let { conditionalRender } = this.props;

    let { openControls, errorMessages, pageData, modalname, LocalVars } = this.props.parentState;
    let isReadOnly1 = false;


    if ((pageData.unique_id && isReadOnly == 'edit') || (conditionalRender && conditionalRender == 'readonly') || (isReadOnly && isReadOnly != 'edit')) {
      isReadOnly1 = true;
    }

    let boxvalue;

    if (openControls.length > 0) {
      if (openControls[openControls.length - 1]['values']) {
        boxvalue = openControls[openControls.length - 1]['values'][name];
      }
    } else {
      boxvalue = pageData[name];
    }

    let textType = "text";

    if (this.props.component.textType) {
      textType = this.props.component.textType;
    }

    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();

    let currentError;
    if (errorMessages) {
      if (modalname && errorMessages[modalname] && errorMessages[modalname][name]) {
        currentError = errorMessages[modalname][name];
      } else if (!modalname && errorMessages[name]) {
        currentError = errorMessages[name];
      }
    }
    let { compressed, ShowHistory } = LocalVars;

    if (insertonly && !ShowHistory) {
      isReadOnly1 = true;
    }
    if (pageData.actionbuttons && tab != "authorizationform") {
      isReadOnly1 = true;
    }
    // if logged in as oro2, then isReadOnly = false.
    let { profile } = this.props.parentProps.parentState;
    if (profile.username == 'oro2') {
      if (name == 'bank_sanction_amount') {
        isReadOnly1 = false;
      } else if (name == 'inspector_amount') {
        isReadOnly1 = true;
      }
    }

    // Check if this passes isrequired validations.
    if (!boxvalue) {
      boxvalue = "";
    }

    return (
      <div className={`form-group ${this.props.component.widths.parent}`} style={{ display: hidden ? "none" : "block" }}>
        {this.state.errorMessage &&
          <Tooltip placement="right" isOpen={this.state.tooltipOpen} target={tooltipID2} toggle={this.toggle}>
            {this.state.errorMessage}
          </Tooltip>
        }

        {conditionalRender && conditionalRender != 'blank' &&
          <div className="input-group input-group-sm">
            {this.props.component.prepend && (
              <div className="input-group-prepend">
                <div className="input-group-text">
                  {this.props.component.prepend}
                </div>
              </div>
            )}

            <input
              autoComplete="off"
              id={tooltipID2}
              style={style}
              maxLength={maxlength}
              tabIndex={tabindex ? tabindex : "0"}
              className={`col-12 form-control form-control-sm primary ${currentError
                ? "validationErrorBox"
                : ""
                } ${!compressed ? "input-compressed" : ""}`}
              // disabled={disabled}
              readOnly={isReadOnly1}
              required={isRequired}
              type={textType}
              name={name}
              placeholder={placeHolder}
              value={boxvalue}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              autoFocus={focus ? true : false}
              onKeyDown={(e) => goToName(e, next_field, name, this)}

            />
            {this.props.component.append && (
              <div className="input-group-append">
                <div className="input-group-text">
                  {this.props.component.append}
                </div>
              </div>
            )}
          </div>

        }

      </div>
    );
  }
}

export default TextCustom;
